
import marketing from '~/mixins/marketing'
export default { mixins: [marketing] }
